import { useTranslation } from 'react-i18next';
import { Spin, Space } from 'antd';

import CardForm from '../CardForm/CardForm';

import Mada from '../../../assets/Mada.svg';
import MasterCard from '../../../assets/MasterCard.svg';
import Visa from '../../../assets/Visa.svg';


interface Props {
    rtl: boolean
    current: string
    shoppingCart: string | null
    handleCardOption: any
    loading: boolean;
    selectRadioOption: string;
}

function CardPayment({ loading, rtl, current, shoppingCart, handleCardOption, selectRadioOption }: Props) {
    const { t } = useTranslation();

    return (
        <div className={rtl ? 'Card__Container CardContainer__Arabic' : 'Card__Container'} style={selectRadioOption === 'card' ? { display: 'block' } : { display: 'none' }}>
            {loading ? (
                <Space size="small">
                    <Spin size="large" />
                </Space>
            ) : (
                <>
                    <div className='Payment__subtitle'>{t("CardDetails")}</div>
                    <div id='cardError' className='cardError'>&nbsp;</div>
                    <div className='Payment__CardSection'>
                        <div className='Payment__chooseCard'>
                            <div className={current === 'mada' ? 'madaCard current__option' : 'madaCard notcurrent__option'} onClick={() => handleCardOption('mada')}>
                                <img src={Mada} alt='mada' />
                            </div>
                            <div className={current === 'visa' ? 'current__option' : 'notcurrent__option'} onClick={() => handleCardOption('visa')}>
                                <img src={Visa} alt='visa' />
                                <img src={MasterCard} alt='master' />
                            </div>
                        </div>
                        <CardForm shoppingCart={shoppingCart} rtl={rtl} />
                    </div>
                </>
            )}
        </div>
    )
}

export default CardPayment;